import React, { Component } from 'react';
import { Spin, Popover } from 'antd';
import CommonCharts from '../../../components/Charts';
import Fetch from '../../../../../common/Fetch';
import ExportUtil from '../../../../../common/ExportUtil';

const GraphicType = 0;
const Colors = {
    "colors10":["#5B8FF9","#61DDAA","#65789B","#F6BD16","#7262fd","#78D3F8","#9661BC","#F6903D","#008685","#F08BB4"],
    "colors20":["#5B8FF9","#CDDDFD","#61DDAA","#CDF3E4","#65789B","#CED4DE","#F6BD16","#FCEBB9","#7262fd","#D3CEFD","#78D3F8","#D3EEF9","#9661BC","#DECFEA","#F6903D","#FFE0C7","#008685","#BBDEDE","#F08BB4","#FFE0ED"]
};

class DoubleAnnulusChart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            externalData: [],
            internalData: [],
            negativeList: [],
            loading: false,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { searchParams: nextSearchParams } = nextProps;
        const { searchParams } = this.props;
        if (nextSearchParams !== searchParams) {
            return false;
        }
        return true;
    }

    componentDidMount() {
        this.loadData();
    }
    
    componentDidUpdate(prevProps) {
        if (prevProps.load !== this.props.load) {
            this.loadData();
        }
    }

    loadData = () => {
        const { searchParams, queryUrl, countType } = this.props;

        this.setState({ loading: true });
        Fetch.post(queryUrl, {
            countType,
            GraphicType,
            ...searchParams,
        }).then(res => {
            const { externalData, internalData, negativeList } = res;
            this.setState({
                externalData,
                internalData,
                negativeList,
                loading: false,
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    handleClick = () => {
        const { searchParams, exportUrl, countType } = this.props;
        ExportUtil.export({ ...searchParams, countType, GraphicType }, null, exportUrl);
    }

    genNegativeDom = () => {
        const { negativeList } = this.state;
        if (!(negativeList || []).length) return;

        const item = (negativeList || []).map((i, x) =>
            <div key={x}>
                <span
                    // style={{ display: 'inline-block', width: 80, textAlign: 'right' }}
                >{i.condition}：</span>
                {i.amountTotal}
            </div>
        );
        return (
            <Popover
                placement="top"
                overlayClassName="contract-pop"
                content={<div>{item}</div>}
            >
                <span className="negative">负值金额</span>
            </Popover>
        );
    }

    render() {
        const { title, height, filename } = this.props;
        const { loading, externalData, internalData } = this.state;
        const colors = (internalData || []).length > 10 ? Colors.colors20 : Colors.colors10;
        let current = 0;
        const colorsLen = colors.length;
        const idToColors = {};
        const innerData = (internalData || []).map((item, index) => {
            const { baUserId, condition, percentageStatisticData } = item;
            const color = colors[current];
            idToColors[baUserId] = color;
            if (current === colorsLen - 1) {
                current = 0
            } else {
                current++;
            }
            return {
                color,
                layer: '内环',
                name: `${condition}`,
                y: Number(percentageStatisticData),
            }
        });
        const outerData = (externalData || []).map((item, index) => {
            const { parentId, condition, percentageStatisticData } = item;
            const color = idToColors[parentId];
            return {
                color,
                layer: '外环',
                name: `${condition}`,
                y: Number(percentageStatisticData),
            }
        });
        let rotation = 0;
        if (
            innerData.length === 2 &&
            innerData.every(i => i.y > 0) &&
            outerData.length === 2 &&
            outerData.every(i => i.y > 0)
        ) {
            rotation = 45;
        }
        return (
            <div className="chart-content">
                <Spin spinning={loading}>
                    <p className="chart-title">{title}</p>
                    <CommonCharts
                        isPie={true}
                        negativeMoney={this.genNegativeDom()}
                        height={height}
                        filename={filename}
                        legend={{
                            labelFormat: '{layer}：{name}'
                        }}
                        plotOptions={{
                            pie: {
                                allowPointSelect: true,
                                cursor: 'pointer',
                                colors,
                                dataLabels: {
                                    rotation,
                                    crop: false,
                                    enabled: true,
                                    formatter: function () {
                                        return this.y >= 5 ? `<b>${this.point.name}</b>: ${(this.point.y).toFixed(2)} %` : null;
                                    },
                                    style: { color: 'black', textOutline: 'none' },
                                },
                                tooltip: {
                                    headerFormat: '',
                                    pointFormat: '<b>{point.name}</b>: {point.y:.2f} %',
                                },
                                showInLegend: true
                            }
                        }}
                        series={[{
                            type: 'pie',
                            size: '70%',
                            innerSize: '50%',
                            data: innerData,
                            dataLabels: {
                                distance: -30
                            }
                        }, {
                            type: 'pie',
                            size: '100%',
                            innerSize: '70%',
                            data: outerData,
                            dataLabels: {
                                distance: -20
                            }
                        }]}
                        onClick={this.handleClick}
                    />
                </Spin>
            </div>
        );
    }
}

export default DoubleAnnulusChart;



// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/RequestToDo/components/ChartsCollection/DoubleAnnulusChart.js